import React, { Component } from 'react';
import '../App.css';
import { observer, inject } from 'mobx-react';
import bg from './bg-survey2.svg';

class Survey2 extends Component {
  handleClick = (event) => {
    var elmnt = document.getElementById('head');
    elmnt.scrollIntoView();
    this.props.StateStore.changeRoute('default');
  };

  render() {
    return (
      <div className='survey2'>
        <h1 className='left-alignment'>
          This is an ongoing Survey hence we can't show you the Results yet.
          Kindly comeback later for checking the Survey Results
        </h1>
        <div className='bg-container'>
          <img src={bg} alt='Ongoing' className='bg-survey2' />
        </div>
        <button onClick={this.handleClick}>Home</button>
      </div>
    );
  }
}

export default inject('StateStore')(observer(Survey2));
